module.exports = __webpack_public_path__ + "static/media/girl-at-home.2aae5863.svg";